import { render, staticRenderFns } from "./difference_confirm.vue?vue&type=template&id=f6d4fc88&scoped=true&"
import script from "./difference_confirm.vue?vue&type=script&lang=js&"
export * from "./difference_confirm.vue?vue&type=script&lang=js&"
import style0 from "./difference_confirm.vue?vue&type=style&index=0&id=f6d4fc88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d4fc88",
  null
  
)

export default component.exports